import { CustomerModel } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";

export class CustomerRepo extends BaseDataRepository<CustomerModel> {
  protected baseUrl = 'customer';

  async searchAsync(query: string): Promise<CustomerModel[]> {
    const escaped = query.trim().replace(/'/g, "''");
    const parts = escaped.split(/\s+/);

    const conditions: string[] = [
      `contains(FirstName,'${escaped}')`,
      `contains(LastName,'${escaped}')`,
      `contains(Phone,'${escaped}')`,
      `contains(Email,'${escaped}')`,
    ];

    if (parts.length >= 2) {
      conditions.push(`(contains(FirstName,'${parts[0]}') and contains(LastName,'${parts[parts.length - 1]}'))`);
    }

    const filter = conditions.join(' or ');
    const response = await this.client.get(`/odata/customers?$filter=${encodeURIComponent(filter)}&$top=10`);
    const raw: any[] = response.data?.value || [];
    return raw.map(c => ({
      id: c.Id,
      userId: c.UserId,
      firstName: c.FirstName,
      lastName: c.LastName,
      phone: c.Phone,
      email: c.Email,
      dateOfBirth: c.DateOfBirth,
      tenantId: c.TenantId,
      addressId: c.AddressId,
    }));
  }
}

export default CustomerRepo;
